"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBanOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M20 12a7.948 7.948 0 01-1.688 4.897L7.103 5.688A7.954 7.954 0 0112 4c4.411 0 8 3.589 8 8zM4 12c0-1.846.634-3.542 1.688-4.897l11.209 11.209A7.954 7.954 0 0112 20c-4.411 0-8-3.589-8-8zm-2 0c0 5.514 4.486 10 10 10s10-4.486 10-10S17.514 2 12 2 2 6.486 2 12z' }))); };
exports.default = SvgBanOutline;
//# sourceMappingURL=BanOutline.js.map